import type { RutaProd } from '../../../../runtime/rutas';
export default { ruta:'/sistema/modulos', alias:['/sistema/modulos/configurar'], documento:'raiz', acceso:'sesion', filas:['154'],
 cita:'Controllers/AccountController.cs:607-628',viewBag:{sinJquery:true} } satisfies RutaProd;
